import { UserAgentApplication, InteractionRequiredAuthError } from 'msal';

const config = {
  clientId: process.env.VUE_APP_AZURE_CLIENT_ID,
  redirectUri: process.env.VUE_APP_PORTAL_URL,
  cacheLocation: 'localStorage',

  auth: {
    authority: 'https://login.microsoftonline.com/' + process.env.VUE_APP_AZURE_TENANT_ID,
    clientId: process.env.VUE_APP_AZURE_CLIENT_ID,
    redirectUri: process.env.VUE_APP_PORTAL_URL
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true
  }
};

export default {
  authenticationContext: null,
  authAgent: null,
  token: null,
  handleWindowCallback: function (err) {
    this.authAgent = new UserAgentApplication(config);
    if (!this.authAgent.isCallback(err)) {
      return;
    }
  },
  initialize: function () {
    this.authAgent = new UserAgentApplication(config);
    if (!this.getCachedToken()) {
      this.login();
    }
  },
  getUserProfile: function () {
    this.authAgent = new UserAgentApplication(config);
    if (this.authAgent.getAccount() !== null) {
      return this.authAgent.getAccount().profile
    } else {
      return null;
    }
  },
  login: function () {
    this.authAgent = new UserAgentApplication(config);
    this.authAgent.loginRedirect();
  },
  getCachedUser: function () {
    this.authAgent = new UserAgentApplication(config);
    return this.authAgent.getAccount();
  },
  getCachedToken: function () {
    this.authAgent = new UserAgentApplication(config);
    if (this.authAgent.getAccount()) {
      const idTokenOnlyScope = [process.env.VUE_APP_AZURE_CLIENT_ID];
      this.token = this.authAgent.acquireTokenSilent({ scopes: idTokenOnlyScope })
        .then(response => {
          return response.idToken;
        }).catch(function (error) {
          console.log(error);
        });
      return this.token;
    } else {
      return null;
    }
  },
  acquireTokenRedirect: function () {
    this.authAgent = new UserAgentApplication(config);
    return this.authAgent.acquireTokenRedirect(process.env.VUE_APP_PORTAL_URL);
  },
  isCallback: function (err) {
    this.authAgent = new UserAgentApplication(config);
    return this.authAgent.handleRedirectCallback((err) => {
      if (err) {
        console.log(err);
        this.isCallback(err);
      }
    });
  }
}